import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import FacultyCard from "./FacultyCard";

const CardCarousel = ({ list = [] }) => {
  return (
    <section className="py-10 px-6 relative">
      <Swiper
        modules={[Navigation, Pagination]}
        navigation={{
          nextEl: ".swiper-button-next-custom",
          prevEl: ".swiper-button-prev-custom",
        }}
        pagination={{ clickable: true }}
        loop={false}
        breakpoints={{
          0: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 0,
          },
        }}
        className="w-full"
      >
        {list.map((card, index) => {
          const isLast = index === list.length - 1;
          const isFirst = index === 0;

          return (
            <SwiperSlide
              key={index}
              className="py-4 flex flex-col items-center text-center relative"
            >
              <FacultyCard {...card} />

              {/* Separator line - show only between cards on lg+ screens */}
              {!isLast && (
                <div
                  className={`hidden lg:block absolute top-0 h-full w-px bg-[rgb(234,126,93)] ${
                    isFirst ? "right-0" : "right-[-1px]"
                  }`}
                ></div>
              )}
            </SwiperSlide>
          );
        })}
      </Swiper>

      {/* Custom Navigation Arrows */}
      <div className="swiper-button-prev-custom absolute left-0 top-1/2 transform -translate-y-1/2 z-10 w-8 h-8 bg-[#EA7E5D] text-white rounded-full flex items-center justify-center cursor-pointer shadow-lg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </div>
      <div className="swiper-button-next-custom absolute right-0 top-1/2 transform -translate-y-1/2 z-10 w-8 h-8 bg-[#EA7E5D] text-white rounded-full flex items-center justify-center cursor-pointer shadow-lg">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-4 h-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </section>
  );
};

export default CardCarousel;